<input
  type="text"
  class="bm-input bm-input-sm w-full"
  placeholder="Bezeichnung, z. B. 12h"
  data-testid="sla-extra-label"
  [maxlength]="maxLabelLength"
  [ngModel]="labelValue()"
  (ngModelChange)="labelValue.set($event ?? '')"
  (keydown.enter)="save()"
  (keydown.esc)="cancel()"
/>
<div class="bm-join w-full">
  <input
    class="bm-input bm-input-sm bm-join-item w-full"
    type="text"
    placeholder="Termin"
    data-testid="sla-extra-at"
    mwlFlatpickr
    [ngModel]="atValue()"
    (ngModelChange)="atValue.set($event)"
    [locale]="'de'"
    [options]="datePickerConfig"
    [convertModelValue]="true"
  />
  <button
    type="button"
    class="flex-none bm-join-item bm-btn bm-btn-primary bm-btn-sm bm-btn-square bm-tooltip"
    data-testid="sla-extra-save"
    [attr.data-tip]="'Speichern'"
    [disabled]="!canSave()"
    (click)="save()"
  >
    <fa-icon [icon]="['far', 'save']" />
  </button>
  <button
    type="button"
    class="flex-none bm-join-item bm-btn bm-btn-sm bm-btn-square bm-tooltip"
    data-testid="sla-extra-clear"
    [attr.data-tip]="'Löschen'"
    (click)="clear()"
  >
    <fa-icon [icon]="['far', 'trash']" />
  </button>
  <button
    type="button"
    class="flex-none bm-join-item bm-btn bm-btn-sm bm-btn-square bm-tooltip"
    data-testid="sla-extra-cancel"
    [attr.data-tip]="'Verwerfen'"
    (click)="cancel()"
  >
    <fa-icon [icon]="['far', 'times']" />
  </button>
</div>
